import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {PopUpService} from './shared/PopUpService';
import {InfoService} from './info/info-service';
import {TranslateService} from '@ngx-translate/core';
import {LoaderService} from './loader/loader.service';
import {Router, NavigationStart, NavigationEnd, NavigationCancel, ActivatedRoute} from '@angular/router';
import {NGXLogger} from 'ngx-logger';

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit {
  subscription: Subscription;
  user: String;
  title = 'Tour of Heroes';
  isReady = false;
  dedicatedBiller = true;

  constructor(private infoService: InfoService,
              public popupservice: PopUpService,
              private router: Router,
              private logger: NGXLogger,
              private loaderService: LoaderService,
              private translate: TranslateService,
              private activatedRoute: ActivatedRoute) {
  }

  isUser: boolean = false;
  url: any;

  ngOnInit() {
    this.url = this.router.url;
    // console.log("URL Current....." + JSON.stringify(this.url));
    // console.log("asasasas..."+this.activatedRoute.snapshot.url); // array of states
    // console.log("dshfhsdjhds..."+this.activatedRoute.snapshot.url[0].path);

    this.logger.debug('app component is called>>>>>>>>>>');
    if (localStorage.getItem('lang') == 'en') {
      this.logger.debug('en is lang');
      localStorage.setItem('lang', 'en');
    } else if (localStorage.getItem('lang') == 'ba') {
      this.logger.debug('ba is lang');
      localStorage.setItem('lang', 'ba');
    } else {
      this.logger.debug('no lang is there');
      this.translate.use('ba');
      localStorage.setItem('lang', 'ba');
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.dedicatedBiller = event.url.startsWith('/dedicated-biller');
      }
    });
  }


  ngAfterViewInit() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isReady = true;
          // this.loaderService.show();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel
        ) {
          //this.loaderService.hide();
          this.isReady = false;
        }
      });
  }

  openRegistration() {
    this.popupservice.isRegister = true;
    this.popupservice.isLogin = false;
  }

  openLogin() {
    this.popupservice.isRegister = false;
    this.popupservice.isLogin = true;
  }

  closeUp() {
    this.popupservice.isInfo = false;
    this.popupservice.isSuccessInfo = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts